import service from '../service/installment'
import CONSTANT from '../constant/installment'
import _ from 'underscore'
export default {
    getInstallmentBanks ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getInstallmentBanks(data).then(result => {
                resolve(result)
                commit(CONSTANT.INSTALLMENT_GETINSTALLMENTBANKS_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.INSTALLMENT_GETINSTALLMENTBANKS_ERROR, e)
            })
        })
    },
    getInstallmentPayPeriods ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getInstallmentPayPeriods(data).then(result => {
                resolve(result)
                commit(CONSTANT.INSTALLMENT_GETINSTALLMENTPAYPERIODS_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.INSTALLMENT_GETINSTALLMENTPAYPERIODS_ERROR, e)
            })
        })
    },
    sendPaySms ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.sendPaySms(data).then(result => {
                resolve(result)
                commit(CONSTANT.INSTALLMENT_SENDPAYSMS_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.INSTALLMENT_SENDPAYSMS_ERROR, e)
            })
        })
    },
    commitInstallment ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.commitInstallment(data).then(result => {
                resolve(result)
                commit(CONSTANT.INSTALLMENT_COMMITINSTALLMENT_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.INSTALLMENT_COMMITINSTALLMENT_ERROR, e)
            })
        })
    },
    checkIsBankCardSupport ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.checkIsBankCardSupport(data).then(result => {
                resolve(result)
                commit(CONSTANT.INSTALLMENT_CHECKISBANKCARDSUPPORT_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.INSTALLMENT_CHECKISBANKCARDSUPPORT_ERROR, e)
            })
        })
    },
    openBankCardPayment ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.openBankCardPayment(data).then(result => {
                resolve(result)
                commit(CONSTANT.INSTALLMENT_OPENBANKCARDPAYMENT_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.INSTALLMENT_OPENBANKCARDPAYMENT_ERROR, e)
            })
        })
    },
    sendSmsForOpenPay ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.sendSmsForOpenPay(data).then(result => {
                resolve(result)
                commit(CONSTANT.INSTALLMENT_SENDSMSFOROPENPAY_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.INSTALLMENT_SENDSMSFOROPENPAY_ERROR, e)
            })
        })
    },
    toOpenPay ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.toOpenPay(data).then(result => {
                resolve(result)
                commit(CONSTANT.INSTALLMENT_TOOPENPAY_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.INSTALLMENT_TOOPENPAY_ERROR, e)
            })
        })
    },
    checkPayResult ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.checkPayResult(data).then(result => {
                resolve(result)
                commit(CONSTANT.INSTALLMENT_CHECKPAYRESULT_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.INSTALLMENT_CHECKPAYRESULT_ERROR, e)
            })
        })
    },
    /*yeoman-template-point-1*/
}